import { memo } from 'react'
import { UserCollectionCell } from '../usersCollection/UserCollectionCell'

export const UsersListCell = memo(props => {
  return <UserCollectionCell className="w-full px-0 py-1" {...props} />
})
